export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=705f64f93eaca8f4c4d71d4fec449ee19a9b50b5e0&name=pushAdClickData!'